import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getCookieConsent, setCookieConsent, initAnalytics } from "@/lib/cookieConsent";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

// Pages publiques (LP/marketing) — afficher le bandeau cookies uniquement ici
const PUBLIC_PREFIXES = [
  '/', '/pricing', '/product', '/use-cases',
  '/blog', '/cgu', '/cgv', '/mentions-legales',
  '/confidentialite', '/contact'
];

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  const isPublicRoute = pathname === '/' || PUBLIC_PREFIXES.some(prefix => prefix !== '/' && pathname.startsWith(prefix));

  useEffect(() => {
    // Afficher le bandeau seulement si aucun choix n'a été fait
    if (getCookieConsent() === null) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent('accepted');
    initAnalytics();
    setVisible(false);
  };

  const handleReject = () => {
    setCookieConsent('rejected');
    setVisible(false);
  };

  if (!visible || !isPublicRoute) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-slate-700 bg-slate-900/95 backdrop-blur-sm">
      <div className="mx-auto max-w-5xl px-4 py-4 sm:px-6 sm:py-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3 sm:items-center">
            <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-amber-400 sm:mt-0" />
            <p className="text-sm text-white/70">
              Nous utilisons des cookies analytiques pour améliorer votre expérience.{" "}
              <Link to="/confidentialite" className="text-amber-400 underline-offset-2 hover:underline">
                En savoir plus
              </Link>
            </p>
          </div>
          <div className="flex shrink-0 gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleReject}
              className="border-slate-600 text-white/70 hover:bg-slate-800 hover:text-white"
            >
              Refuser
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-amber-500 text-slate-900 hover:bg-amber-400"
            >
              Accepter
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
